import { render, staticRenderFns } from "./user-mark.vue?vue&type=template&id=1c875aa0&scoped=true&"
import script from "./user-mark.vue?vue&type=script&lang=js&"
export * from "./user-mark.vue?vue&type=script&lang=js&"
import style0 from "./user-mark.vue?vue&type=style&index=0&id=1c875aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c875aa0",
  null
  
)

export default component.exports